import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
var threadListParams = {
  perPage: 10,
  page: 1,
  'filter[essence]': 0,
  'filter[attention]': 0,
  'filter[sort]': 3,
  sequence: 0
};
import { threadList } from '@/api/mg';
export default {
  watch: {
    inputValue: function inputValue() {
      threadListParams['filter[search]'] = this.inputValue;
      this.getThreadList(threadListParams);
    }
  },
  props: ['inputValue'],
  data: function data() {
    return {
      allData: [],
      nodata: false
    };
  },
  created: function created() {
    threadListParams.page = 1;
    threadListParams['filter[search]'] = this.inputValue;
    this.getThreadList(threadListParams);
  },
  methods: {
    getThreadList: function getThreadList(params) {
      var _this = this;
      threadList(params).then(function (res) {
        if (res.Code === 0) {
          _this.allData = res.Data.pageData;
          if (_this.allData.length === 0) {
            _this.nodata = true;
          } else {
            _this.nodata = false;
            if (_this.allData['1']) {
              _this.allData['1'].forEach(function (itm) {
                itm.content.text = _this.filter(itm.content.text);
              });
            } else {
              _this.nodata = true;
            }
            if (_this.allData['2']) {
              _this.allData['2'].forEach(function (itm) {
                itm.content.text = _this.filter(itm.content.text);
              });
            }
            if (_this.allData['4']) {
              _this.allData['4'].forEach(function (itm) {
                itm.content.text = _this.filter(itm.content.text);
              });
            }
          }
          console.log(_this.allData, 'this.allData');
        } else {
          _this.$toast(res.Message);
        }
      });
    },
    toChange: function toChange(name) {
      this.$emit('tabChange', name);
    },
    toDetail: function toDetail(val, threadId) {
      this.$router.push({
        path: '/social/detail',
        query: {
          from: val,
          threadId: threadId,
          back: 'index'
        }
      });
    },
    filter: function filter(html) {
      return html.replace(/<(?:.|\n)*?>/gm, '').replace(/(&rdquo;)/g, '"').replace(/&ldquo;/g, '"').replace(/&mdash;/g, '-').replace(/&nbsp;/g, '').replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/<[\w\s"':=\/]*/, '');
    }
  }
};